import { StyledAddBroadsider } from './AddBroadsider.styled';

const AddBroadsider = ({ onClick }) => {
  return (
    <div onClick={() => onClick ? onClick() : false }>
      <StyledAddBroadsider>
        <div style={{width: '100%', height: '100%', overflow: 'hidden'}}>
	  <img className='add-bsider-img' src='/assets/add_broadsider.svg' />
        </div>
        <div className='add-bsider-decorator'>
          <div>
	    <img src='/assets/add_broadsider_plus.svg' />
	  </div>
        </div>
      </StyledAddBroadsider>
    </div>
  );
};

export default AddBroadsider;
